import { i18n } from '@/helpers/translations';

export const moduleOptionsLabel = (moduleSlug: string): string => {
  const key = 'communities.configuration.labels.' + moduleSlug;
  return (i18n.te(key) ? i18n.t(key) : i18n.t('communities.configuration.labels.default')) as string;
};
